var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 923.1 273.9",
    style: {
      enableBackground: "new 0 0 923.1 273.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#A6A6A6;}\r\n\t.st2{fill:#00C1FF;}\r\n\t.st3{fill:url(#SVGID_1_);}\r\n\t.st4{fill:url(#SVGID_00000011012202580792869820000009603781779223259819_);}\r\n\t.st5{fill:url(#SVGID_00000153670959857881809560000010448482484445178807_);}\r\n\t.st6{fill:url(#SVGID_00000122691980854465258560000016616158177807175572_);}\r\n\t.st7{fill:url(#SVGID_00000062192580607580638460000006682048550203428018_);}\r\n\t.st8{fill:url(#SVGID_00000076603817948227802150000014438182819569852063_);}\r\n\t.st9{fill:url(#SVGID_00000131326413657544837430000008344074556053687727_);}\r\n\t.st10{fill:url(#SVGID_00000078022958667574754060000006516998904643632053_);}\r\n\t.st11{fill:url(#SVGID_00000126320790075451348640000010222792203929577646_);}\r\n\t.st12{fill:url(#SVGID_00000023967855345156853110000014274395196617254785_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M888.9,273.9H34.2C15.4,273.9,0,258.5,0,239.7V34.2C0,15.4,15.4,0,34.2,0h854.7c18.8,0,34.2,15.4,34.2,34.2 v205.5C923.1,258.5,907.7,273.9,888.9,273.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M888.9,0H34.2C15.4,0,0,15.4,0,34.2v205.5c0,18.8,15.4,34.2,34.2,34.2h854.7c18.8,0,34.2-15.4,34.2-34.2V34.2 C923.1,15.4,907.7,0,888.9,0 M888.9,5.5c15.8,0,28.7,12.9,28.7,28.8v205.5c0,15.9-12.9,28.8-28.7,28.8H34.2 c-15.8,0-28.7-12.9-28.7-28.8V34.2c0-15.9,12.9-28.8,28.7-28.8L888.9,5.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M324.2,70.2c0,5.7-1.7,10.3-5.1,13.7c-3.9,4.1-8.9,6.1-15.1,6.1c-5.9,0-11-2.1-15.1-6.2c-4.1-4.1-6.2-9.2-6.2-15.3 c0-6.1,2.1-11.2,6.2-15.3c4.1-4.1,9.2-6.2,15.1-6.2c2.9,0,5.8,0.6,8.4,1.7c2.7,1.2,4.8,2.7,6.4,4.6l-3.6,3.6 c-2.7-3.3-6.5-4.9-11.2-4.9c-4.3,0-8.1,1.5-11.2,4.6c-3.2,3-4.7,7-4.7,11.9c0,4.9,1.6,8.8,4.7,11.9c3.2,3,6.9,4.6,11.2,4.6 c4.6,0,8.4-1.5,11.5-4.6c2-2,3.1-4.8,3.4-8.3h-14.9v-4.9h19.9C324.1,68.1,324.2,69.2,324.2,70.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M324.2,70.2h-0.7c0,5.6-1.6,10-4.9,13.2l0,0l0,0c-3.7,3.9-8.5,5.9-14.6,5.9c-5.8,0-10.6-2-14.6-6c-4-4-6-8.9-6-14.8 c0-5.9,2-10.8,6-14.8c4-4,8.9-6,14.6-6c2.9,0,5.6,0.6,8.2,1.7c2.6,1.1,4.6,2.6,6.2,4.4l0.5-0.4l-0.5-0.5l-3.6,3.6l0.5,0.5l0.5-0.4 c-2.8-3.4-6.8-5.1-11.8-5.1c-4.5,0-8.4,1.6-11.7,4.8c-3.3,3.2-4.9,7.3-4.9,12.3c0,5,1.6,9.2,4.9,12.3c3.3,3.2,7.2,4.8,11.7,4.8 c4.7,0,8.8-1.6,11.9-4.8c2.1-2.1,3.3-5.1,3.6-8.7l0.1-0.7h-15v-3.6h19.2v-0.7l-0.7,0.1c0.2,1,0.3,2,0.3,3h1.4c0-1-0.1-2.1-0.3-3.2 l-0.1-0.6h-21.1v6.3H319V72l-0.7-0.1c-0.3,3.4-1.4,6-3.2,7.9c-2.9,2.9-6.5,4.4-11,4.4c-4.2,0-7.7-1.4-10.7-4.4 c-3-2.9-4.5-6.6-4.5-11.4c0-4.7,1.5-8.4,4.5-11.4c3-2.9,6.6-4.4,10.7-4.4c4.6,0,8.1,1.5,10.7,4.6l0.5,0.6l4.1-4.1l0.4-0.4l-0.4-0.5 c-1.7-2-3.9-3.6-6.7-4.8c-2.8-1.2-5.7-1.8-8.7-1.8c-6.1,0-11.3,2.1-15.6,6.4c-4.3,4.2-6.4,9.5-6.4,15.8c0,6.2,2.1,11.6,6.4,15.8 c4.3,4.2,9.5,6.4,15.6,6.4c6.3,0,11.6-2.1,15.6-6.3l-0.5-0.5l0.5,0.5c3.5-3.5,5.3-8.3,5.3-14.2L324.2,70.2 M355.7,53h-18.7v13h16.8 V71h-16.8v13h18.7v5h-24V47.9h24V53"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M355.7,53v-0.7h-19.4v14.4h16.8v3.6l-16.8,0v14.4h18.7v3.7h-22.6V48.6h22.6V53L355.7,53v-0.7V53l0.7,0v-5.7h-25.3v42.5 h25.3v-6.4h-18.7V71.6h16.8v-6.3h-16.8V53.7h18.7V53L355.7,53 M378,89h-5.3V53h-11.5v-5h28.2v5H378V89"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M378,89v-0.7h-4.6v-36h-11.5v-3.7h26.8v3.7h-11.5V89L378,89l0-0.7L378,89l0.7,0V53.7h11.5v-6.4h-29.6v6.4H372v36h6.6V89 L378,89 M409.8,89V47.9h5.3V89L409.8,89"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M409.8,89h0.7V48.6h3.9v39.7h-4.6V89l0.7,0L409.8,89v0.7h6V47.3h-6.6v42.5h0.7V89 M438.5,89h-5.3V53h-11.5v-5h28.2v5h-11.5 V89"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M438.5,89v-0.7h-4.6v-36h-11.5v-3.7h26.8v3.7h-11.5V89L438.5,89l0-0.7L438.5,89l0.7,0V53.7h11.5v-6.4h-29.6v6.4h11.5v36 h6.6V89L438.5,89 M477.1,80.3c3,3.1,6.8,4.6,11.1,4.6c4.4,0,8.1-1.5,11.1-4.6c3-3.1,4.6-7,4.6-11.8c0-4.8-1.5-8.7-4.6-11.8 c-3-3.1-6.7-4.6-11.1-4.6c-4.4,0-8.1,1.5-11.1,4.6c-3,3.1-4.6,7-4.6,11.8C472.6,73.3,474.1,77.2,477.1,80.3z M503.3,83.7 c-4,4.2-9,6.2-15,6.2c-6,0-11-2.1-15-6.2c-4-4.1-6-9.2-6-15.2s2-11.1,6-15.2c4-4.2,9-6.2,15-6.2c6,0,11,2.1,15,6.3 c4,4.2,6.1,9.2,6.1,15.2C509.4,74.5,507.3,79.6,503.3,83.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M477.1,80.3l-0.5,0.5c3.1,3.2,7.1,4.8,11.6,4.8c4.6,0,8.5-1.6,11.6-4.8c3.2-3.2,4.8-7.4,4.8-12.3c0-4.9-1.6-9.1-4.8-12.3 c-3.1-3.2-7.1-4.8-11.6-4.8c-4.6,0-8.5,1.6-11.6,4.8c-3.2,3.2-4.8,7.4-4.8,12.3c0,4.9,1.6,9.1,4.8,12.3L477.1,80.3l0.5-0.5 c-2.9-3-4.4-6.7-4.4-11.3c0-4.6,1.5-8.4,4.4-11.3c2.9-3,6.4-4.4,10.7-4.4c4.2,0,7.7,1.5,10.7,4.4c2.9,3,4.4,6.7,4.4,11.3 c0,4.6-1.5,8.4-4.4,11.3c-2.9,3-6.4,4.4-10.7,4.4c-4.2,0-7.7-1.5-10.7-4.4L477.1,80.3z M503.3,83.7l-0.5-0.5c-3.9,4-8.7,6-14.6,6 c-5.8,0-10.6-2-14.5-6l0,0l0,0c-3.9-4-5.8-8.9-5.8-14.8c0-5.9,1.9-10.7,5.8-14.8c3.9-4,8.7-6,14.5-6c5.8,0,10.6,2,14.5,6.1 c3.9,4.1,5.9,8.9,5.9,14.7c0,5.9-1.9,10.7-5.8,14.8L503.3,83.7l0.5,0.5c4.1-4.3,6.2-9.6,6.2-15.7c0-6.1-2.1-11.4-6.3-15.7 c-4.2-4.3-9.4-6.5-15.5-6.5c-6.2,0-11.4,2.2-15.5,6.4v0c-4.2,4.3-6.2,9.6-6.2,15.7c0,6.2,2.1,11.4,6.2,15.7l0,0l0,0 c4.1,4.3,9.4,6.4,15.5,6.4c6.2,0,11.4-2.2,15.5-6.4L503.3,83.7z M516.8,89V47.9h6.4l19.9,32h0.2l-0.2-7.9v-24h5.3V89h-5.5L522,55.5 h-0.2l0.2,7.9V89L516.8,89"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M516.8,89h0.7V48.6h5.4l19.9,32h1.3l-0.2-8.6V48.6h3.9v39.7h-4.4l-20.9-33.5h-1.3l0.2,8.6v24.9h-4.6L516.8,89l0.7,0 L516.8,89l0,0.7h6V63.4l-0.2-7.9l-0.7,0v0.7h0.2v-0.7l-0.6,0.4l21.1,33.8h6.6V47.3h-6.6V72l0.2,7.9l0.7,0v-0.7h-0.2v0.7l0.6-0.4 l-20.1-32.3h-7.5v42.5h0.7L516.8,89 M731.2,205.5h12.8v-85.6h-12.8L731.2,205.5z M846.1,150.7l-14.6,37.1H831l-15.2-37.1h-13.7 l22.8,51.9l-13,28.9h13.3l35.1-80.7L846.1,150.7z M773.8,195.7c-4.2,0-10-2.1-10-7.3c0-6.6,7.3-9.1,13.5-9.1 c5.6,0,8.2,1.2,11.7,2.9C787.9,190.1,781.1,195.7,773.8,195.7L773.8,195.7z M775.3,148.8c-9.2,0-18.8,4.1-22.8,13.1l11.3,4.7 c2.4-4.7,6.9-6.3,11.7-6.3c6.6,0,13.3,4,13.4,11v0.9c-2.3-1.3-7.3-3.3-13.3-3.3c-12.2,0-24.6,6.7-24.6,19.3 c0,11.5,10,18.8,21.2,18.8c8.6,0,13.3-3.9,16.3-8.4h0.4v6.6h12.3v-32.8C801.2,157.3,789.9,148.8,775.3,148.8L775.3,148.8z  M696.4,161.1h-18.1v-29.3h18.1c9.5,0,15,7.9,15,14.7C711.4,153.1,706,161.1,696.4,161.1z M696.1,119.8h-30.6v85.6h12.8V173h17.8 c14.1,0,28-10.3,28-26.6C724.2,130.1,710.2,119.8,696.1,119.8L696.1,119.8z M529.4,195.8c-8.8,0-16.2-7.4-16.2-17.5 c0-10.3,7.4-17.8,16.2-17.8c8.7,0,15.5,7.5,15.5,17.8C544.9,188.4,538.1,195.8,529.4,195.8L529.4,195.8z M544.1,155.5h-0.4 c-2.9-3.4-8.4-6.5-15.3-6.5c-14.5,0-27.9,12.8-27.9,29.2c0,16.3,13.3,29,27.9,29c6.9,0,12.4-3.1,15.3-6.6h0.4v4.2 c0,11.1-5.9,17.1-15.5,17.1c-7.8,0-12.7-5.6-14.7-10.4l-11.1,4.6c3.2,7.7,11.7,17.2,25.8,17.2c15,0,27.6-8.8,27.6-30.3v-52.3h-12.1 V155.5z M565,205.5h12.8v-85.6H565V205.5z M596.6,177.2c-0.3-11.3,8.7-17,15.2-17c5.1,0,9.4,2.5,10.8,6.2L596.6,177.2z  M636.3,167.5c-2.4-6.5-9.8-18.5-24.9-18.5c-15,0-27.4,11.8-27.4,29.1c0,16.3,12.3,29.1,28.9,29.1c13.3,0,21-8.2,24.2-12.9 l-9.9-6.6c-3.3,4.9-7.8,8.1-14.3,8.1c-6.5,0-11.1-3-14.1-8.8l38.9-16.1L636.3,167.5z M326.5,157.9v12.4H356c-0.9,7-3.2,12-6.7,15.6 c-4.3,4.3-11,9-22.8,9c-18.2,0-32.4-14.7-32.4-32.9c0-18.2,14.2-32.9,32.4-32.9c9.8,0,17,3.9,22.3,8.8l8.7-8.7 c-7.4-7.1-17.2-12.5-31-12.5c-24.9,0-45.8,20.3-45.8,45.2c0,24.9,20.9,45.2,45.8,45.2c13.4,0,23.6-4.4,31.5-12.7 c8.2-8.2,10.7-19.6,10.7-28.9c0-2.9-0.2-5.5-0.7-7.7L326.5,157.9z M402.2,195.8c-8.8,0-16.4-7.3-16.4-17.7 c0-10.5,7.6-17.7,16.4-17.7c8.8,0,16.4,7.2,16.4,17.7C418.6,188.5,411,195.8,402.2,195.8z M402.2,149c-16.1,0-29.2,12.2-29.2,29.1 c0,16.8,13.1,29.1,29.2,29.1c16.1,0,29.2-12.4,29.2-29.1C431.4,161.2,418.3,149,402.2,149z M465.9,195.8c-8.8,0-16.4-7.3-16.4-17.7 c0-10.5,7.6-17.7,16.4-17.7c8.8,0,16.4,7.2,16.4,17.7C482.3,188.5,474.7,195.8,465.9,195.8L465.9,195.8z M465.9,149 c-16.1,0-29.2,12.2-29.2,29.1c0,16.8,13.1,29.1,29.2,29.1c16.1,0,29.2-12.4,29.2-29.1C495.1,161.2,482,149,465.9,149L465.9,149z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.9,52.1c-2.3,2.1-3.7,5.5-3.7,10.1v-1v151.5v-1c0,4.2,1.2,7.5,3.2,9.6l0.5,0.5v0c1.6,1.5,3.7,2.2,6,2.2 c2.3,0,4.9-0.7,7.7-2.3l99.2-56.5l34.1-19.4c4.3-2.5,6.8-5.6,7.2-8.9v0c-0.4-3.2-2.8-6.4-7.2-8.9l-34.1-19.4L85.6,52.2 c-2.8-1.6-5.4-2.3-7.7-2.3C75.5,49.9,73.5,50.7,71.9,52.1L71.9,52.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2419.6157,
    y1: 625.7019,
    x2: 2279.4888,
    y2: 895.1909,
    gradientTransform: "matrix(0.2221 0 0 0.4265 -414.7249 -206.8068)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.006569999,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M71.9,221.8l-0.5-0.5c-2-2.1-3.2-5.4-3.2-9.6v1V61.3v1c0-4.6,1.4-8,3.7-10.1l84.7,84.9L71.9,221.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053526306293207299380000001662594658793358481_",
    gradientUnits: "userSpaceOnUse",
    x1: 1558.4409,
    y1: 1161.8724,
    x2: 1073.4359,
    y2: 1161.8724,
    gradientTransform: "matrix(0.3411 0 0 0.2777 -300.2841 -185.6913)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053526306293207299380000001662594658793358481_)"
    },
    d: "M184.8,165.3L156.6,137l28.2-28.3 l34.1,19.4c4.3,2.5,6.8,5.6,7.2,8.9v0c-0.4,3.2-2.8,6.4-7.2,8.9L184.8,165.3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079488048167424381640000013719813775994376886_",
    gradientUnits: "userSpaceOnUse",
    x1: 1554.629,
    y1: 1033.7947,
    x2: 1112.5541,
    y2: 1372.6426,
    gradientTransform: "matrix(0.3506 0 0 0.2702 -382.8373 -123.2073)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3A44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31162"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079488048167424381640000013719813775994376886_)"
    },
    d: "M77.9,224.1c-2.4,0-4.4-0.8-6-2.2v0 l84.7-84.8l28.2,28.3l-99.2,56.5C82.8,223.3,80.2,224.1,77.9,224.1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156561334185378300400000007709049448971346611_",
    gradientUnits: "userSpaceOnUse",
    x1: 1213.3079,
    y1: 951.441,
    x2: 1410.407,
    y2: 1102.7461,
    gradientTransform: "matrix(0.3506 0 0 0.2702 -382.768 -210.1004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156561334185378300400000007709049448971346611_)"
    },
    d: "M156.6,137L71.9,52.1 c1.6-1.5,3.7-2.2,6-2.2c2.3,0,4.9,0.7,7.7,2.3l99.2,56.5L156.6,137"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115473641866302957450000015902440423052993701_",
    gradientUnits: "userSpaceOnUse",
    x1: 1294.7014,
    y1: 1611.2135,
    x2: 1294.7014,
    y2: 1611.2135,
    gradientTransform: "matrix(0.3506 0 0 0.2702 -382.768 -210.1004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115473641866302957450000015902440423052993701_)"
    },
    d: "M71.1,225.3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157988096713319938900000006934282514159688091_",
    gradientUnits: "userSpaceOnUse",
    x1: 2826.5364,
    y1: 620.08,
    x2: 2750.7324,
    y2: 839.664,
    gradientTransform: "matrix(0.181 0 0 0.5234 -423.7934 -256.622)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#008DE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.006569999,
    style: {
      stopColor: "#008DE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#00A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#00B8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#00C4E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C7E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157988096713319938900000006934282514159688091_)"
    },
    d: "M71.4,222.3c-2-2.1-3.2-5.4-3.2-9.6v-1 c0,4.2,1.2,7.5,3.2,9.6l0.5,0.5L71.4,222.3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020374427105350943660000000601471744906226073_",
    gradientUnits: "userSpaceOnUse",
    x1: 1353.3201,
    y1: 1266.02,
    x2: 903.2841,
    y2: 1266.02,
    gradientTransform: "matrix(0.3676 0 0 0.2577 -266.1841 -174.7987)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0C500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#E0A600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#E09100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E08900"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020374427105350943660000000601471744906226073_)"
    },
    d: "M185.4,165.9l-0.6-0.6l34.1-19.4 c4.3-2.5,6.8-5.6,7.2-8.9c0,1.2-0.3,2.4-0.8,3.5c-1.1,2.3-3.2,4.5-6.4,6.3L185.4,165.9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106826744994867856140000008351546006038988989_",
    gradientUnits: "userSpaceOnUse",
    x1: 1353.3463,
    y1: 1265.3512,
    x2: 903.3043,
    y2: 1265.3512,
    gradientTransform: "matrix(0.3676 0 0 0.2577 -266.1854 -203.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE840"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FFCE40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FFBC40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB540"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106826744994867856140000008351546006038988989_)"
    },
    d: "M226.1,137c-0.4-3.2-2.8-6.4-7.2-8.9 l-34.1-19.4l0.6-0.6h0l33.5,19C223.7,129.8,226.1,133.4,226.1,137"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098908842098935818570000000507373456301431955_",
    gradientUnits: "userSpaceOnUse",
    x1: 2736.1091,
    y1: 892.7148,
    x2: 2660.7302,
    y2: 1102.1819,
    gradientTransform: "matrix(0.1807 0 0 0.5242 -423.8483 -417.2561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40B8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.006569999,
    style: {
      stopColor: "#40B9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#40CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#40DDFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#40E7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40EAFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098908842098935818570000000507373456301431955_)"
    },
    d: "M68.2,62.3v-1c0-0.4,0-0.7,0-1.1v0 c0,0,0,0,0,0v0c0.2-3.7,1.3-6.5,3.1-8.4l0.5,0.5C69.6,54.2,68.2,57.7,68.2,62.3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026136176275836413930000008486538442783603601_",
    gradientUnits: "userSpaceOnUse",
    x1: 2738.4619,
    y1: 1003.8018,
    x2: 2738.4619,
    y2: 1003.8018,
    gradientTransform: "matrix(0.1807 0 0 0.5242 -423.8483 -417.2561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40B8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.006569999,
    style: {
      stopColor: "#40B9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#40CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#40DDFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#40E7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40EAFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026136176275836413930000008486538442783603601_)"
    },
    d: "M71.1,108.9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google_play.40fdf511cf0e98acf323fcbd02b01ac8.svg";
export { ForwardRef as ReactComponent };